import type { FC, ReactElement, ReactNode } from "react"

import { AnimatePresence, motion, useReducedMotion } from "framer-motion"

import { EUserRole } from "@/3514/types"

import styles from "./header-meta.styles"

interface HeaderMetaViewProps {
    role: EUserRole
    motionKey: string
    children: ReactNode
    isVisible: boolean
}

const HeaderMetaView: FC<HeaderMetaViewProps> = ({
    role,
    motionKey,
    children,
    isVisible
}: HeaderMetaViewProps): ReactElement => {
    const isMotionReduced: boolean = useReducedMotion()

    const isCoach: boolean = role === EUserRole.Coach

    const isAssistant: boolean = role === EUserRole.Assistant

    return (
        <AnimatePresence presenceAffectsLayout mode="sync">
            {isVisible && (
                <motion.div
                    key={motionKey}
                    initial={{ ...(isAssistant && { opacity: 0, x: -15 }), ...(isCoach && { opacity: 0, y: -15 }) }}
                    animate={{ ...(isAssistant && { opacity: 1, x: 0 }), ...(isCoach && { opacity: 1, y: 0 }) }}
                    transition={{ duration: isMotionReduced ? 0 : 0.2, delay: 0.1 }}
                    className={styles[role].userInfoContainer()}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    )
}

HeaderMetaView.displayName = "HeaderMetaView"

export { HeaderMetaView }
